import { Box, ToggleButton, ToggleButtonGroup } from '@mui/material';
import { defineMessage, FormattedMessage } from 'react-intl';
import { stationsEnum } from '../helpers';

const currentStationMessage = defineMessage({
  id: 'logger.streamScreen.youtubeStats.currentStation',
  defaultMessage: 'Emisora actual',
});

const allStationsMessage = defineMessage({
  id: 'logger.streamScreen.youtubeStats.allStations',
  defaultMessage: 'Todos los canales',
});

const oneHourMessage = defineMessage({
  id: 'logger.streamScreen.youtubeStats.hour',
  defaultMessage: 'Hora',
});

const hoursMessage = defineMessage({
  id: 'logger.streamScreen.youtubeStats.hours',
  defaultMessage: 'Horas',
});

export type YoutubeStatsToolbarV2Props = {
  stationsSelection: string;
  setStationsSelection: (stationsSelection: string) => void;
  dateRange: { label: string; range: { from: string; to: string } };
  dateRanges: { label: string; range: { from: string; to: string } }[];
  handleDateRangeChange: (selectedLabel: string) => void;
};

/**
 * Scope toggles (current / all) and time window toggles for YouTube stats v2.
 * Individual channel visibility is controlled from the chart legend.
 */
export function YoutubeStatsToolbarV2(props: YoutubeStatsToolbarV2Props) {
  const { stationsSelection, setStationsSelection, dateRange, dateRanges, handleDateRangeChange } =
    props;

  return (
    <Box
      sx={{
        alignSelf: 'stretch',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'baseline',
        flexWrap: 'wrap',
        gap: 2,
        mx: 4,
      }}
    >
      <ToggleButtonGroup
        size="small"
        value={stationsSelection}
        exclusive
        onChange={(_, value) => value && setStationsSelection(value)}
      >
        <ToggleButton value={stationsEnum.current}>
          <FormattedMessage {...currentStationMessage} />
        </ToggleButton>
        <ToggleButton value={stationsEnum.all}>
          <FormattedMessage {...allStationsMessage} />
        </ToggleButton>
      </ToggleButtonGroup>

      <ToggleButtonGroup
        size="small"
        value={dateRange.label}
        exclusive
        onChange={(_, value) => value && handleDateRangeChange(value)}
      >
        <ToggleButton value={dateRanges[0].label}>
          1 <FormattedMessage {...oneHourMessage} />
        </ToggleButton>
        <ToggleButton value={dateRanges[1].label}>
          3 <FormattedMessage {...hoursMessage} />
        </ToggleButton>
        <ToggleButton value={dateRanges[2].label}>
          6 <FormattedMessage {...hoursMessage} />
        </ToggleButton>
        <ToggleButton value={dateRanges[3].label}>
          12 <FormattedMessage {...hoursMessage} />
        </ToggleButton>
        <ToggleButton value={dateRanges[4].label}>
          24 <FormattedMessage {...hoursMessage} />
        </ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
}
